export default "__VITE_ASSET__D_poGxVz__$_?component__"